import { MultiplesSingleSelectionType, SinglesSingleSelectionType } from './LiabilitiesWidgetTable.types';
import Icon from 'src/components/Icon/Icon';
import React from 'react';
import { toNumber } from 'lodash';

export const getMultiplesRowClassName = ({ sgl: { totalBetsNum } }: MultiplesSingleSelectionType): string => {
    const cls = [];

    if (totalBetsNum < 0) {
        cls.push('market-liabilities__row--danger');
    }

    return cls.join(' ');
};

export const getSinglesRowClassName = ({ sgl: { profit } }: SinglesSingleSelectionType): string => {
    const cls = [];

    if (toNumber(profit) < 0) {
        cls.push('market-liabilities__row--danger');
    }

    return cls.join(' ');
};

export const getSortIndicator = (column: string, sortColumn: string, sortDirection: string): JSX.Element | null => {
    if (sortColumn !== column) {
        return null;
    }

    if (sortDirection === 'asc') {
        return <Icon name='up' />;
    }

    return <Icon name='down' />;
};

export const createSearchParams = (
    type: 'single' | 'multiple',
    selection: MultiplesSingleSelectionType | SinglesSingleSelectionType,
    eventId?: number | undefined
): string => {
    const params: Record<string, string> = {
        type,
    };
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    if (selection.id !== undefined) {
        params.selection = selection.id;
    }
    if (eventId !== undefined) {
        params.event = eventId.toString();
    }
    return JSON.stringify(params);
};
